import React from "react";
import Link from "@irati/ui/src/Link";
import { injectIntl } from "@irati/utils/lang";
import { AppAdContainer, AppAdImage, BadgesContainer, Panel } from "../styled";
import badgeApple from "../../images/badgeApple.svg";
import badgeGoogle from "../../images/badgeGoogle.svg";
var AppAd = function (props) { return (React.createElement(Panel, null,
    React.createElement(AppAdContainer, null,
        React.createElement(AppAdImage, { src: props.formatMessage({ id: "platform.appAdvert.source" }), alt: "Download the pp" }),
        React.createElement(Badges, { formatMessage: props.formatMessage })))); };
var Badges = function (props) { return (React.createElement(BadgesContainer, null,
    React.createElement(Link, { href: props.formatMessage({ id: "home.appAd.ios.href" }), target: "_blank", plain: true },
        React.createElement("img", { src: badgeApple, alt: "Apple badge" })),
    React.createElement(Link, { href: props.formatMessage({ id: "home.appAd.android.href" }), target: "_blank", plain: true },
        React.createElement("img", { src: badgeGoogle, alt: "Google badge" })))); };
export default injectIntl(AppAd);
